export default "__VITE_ASSET__DqEC5C5b__";